<template>
  <section class="roomCard">
    <div class="roomCard__container">
      <div
        class="roomCard__roomName"
        :style="{ borderLeft: color[getPlatformClass(room?.platformType)] }"
        tabindex="0"
        :aria-describedby="showPlatformTooltip && platformTooltipText(roomsPlatformType) ? platformTooltipId : null"
        @mouseenter="setPlatformTooltipVisibility(true)"
        @mouseleave="setPlatformTooltipVisibility(false)"
        @focusin="setPlatformTooltipVisibility(true)"
        @focusout="setPlatformTooltipVisibility(false)">
        <p>{{ getNameRoom.name }}</p>
        <ToolTip v-if="showPlatformTooltip && platformTooltipText(roomsPlatformType)" :id="platformTooltipId" role="tooltip" :text="platformTooltipText(roomsPlatformType)" variant="right" />
      </div>
      <div v-for="section in turnSections" :key="section.key">
        <div class="roomCard__turnContainer" v-if="section.items.length">
          <div :class="['roomCard__turn', ind.register ? 'r' : section.classSuffix]" v-for="(ind, idx) in section.items" :key="getUserIdentifier(ind, idx, section.key)">
            <component :is="ind.register ? 'router-link' : 'div'" class="roomCard__link" v-bind="ind.register ? { to: getLink(ind._id), target: '_blank' } : {}">
              <div
                class="roomCard__avatarWrapper"
                @mouseenter="handleAvatarHover(getUserIdentifier(ind, idx, section.key), ind, true)"
                @mouseleave="handleAvatarHover(getUserIdentifier(ind, idx, section.key), ind, false)">
                <avatar :class="`roomCard__imgModel roomCard__imgModel-${getPlatformClass(ind?.platformType)}`" :user="getUser(ind)" />
                <ToolTip v-if="shouldShowFreeTooltip(getUserIdentifier(ind, idx, section.key), ind)" :text="platformTooltipText(ind?.platformType)" variant="down" />
              </div>
              <p class="roomCard__text">{{ ind.artisticName }}</p>
            </component>
          </div>
        </div>
        <div
          :class="`roomCard__text roomCard__else roomCard__else--${getNameRoom.isEnable !== false ? true : false}`"
          v-else
          v-html="getNameRoom.isEnable !== false ? 'Habilitada' : 'Deshabilitada'"></div>
      </div>
    </div>
  </section>
</template>

<script>
  import ToolTip from "@/components/atoms/ToolTip.vue";
  import { mapGetters } from "vuex";

  export default {
    name: "roomCard",
    props: {
      room: Array[Object],
    },
    components: { ToolTip },
    data() {
      return {
        morning: [],
        late: [],
        nigth: [],
        rooms: this.room,
        color: { both: "solid 4px #EF9E25", free: "solid 4px #7f19ad", private: "#fff", group: "solid 4px #1f86cb" },
        showPlatformTooltip: false,
        hoveredFreeUserId: null,
      };
    },
    computed: {
      platformTooltipId() {
        const id = this.rooms?._id || this.room?._id || this._uid;
        return `roomCard-platform-tooltip-${id}`;
      },
      getNameRoom: function () {
        const number = this.rooms?.roomName.match(/\d+/gi) || "";
        return { name: `${this.rooms?.roomName.match(/[a-z]+/gi)} ${number}`.trim(), isEnable: this.room.isEnable };
      },
      turnSections() {
        return [
          { key: "morning", items: this.morning, classSuffix: "m" },
          { key: "late", items: this.late, classSuffix: "l" },
          { key: "night", items: this.nigth, classSuffix: "n" },
        ];
      },
      roomsPlatformType() {
        return this.rooms?.platformType || this.room?.platformType;
      },
      ...mapGetters("applications", {
        getAppByName: "getAppByName",
      }),
    },
    methods: {
      platformTooltipText(platformType) {
        if (!Array.isArray(platformType) || platformType.length === 0) return "";

        const map = {
          free: "Free",
          private: "Privada",
          group: "Grupal",
        };

        const hasFree = platformType.includes("free");
        const hasPrivate = platformType.includes("private");

        if (hasFree && hasPrivate) return "Free / Priv";
        if (platformType.length === 1) return map[platformType[0]] || "";

        return "";
      },
      getPlatformClass(pt) {
        if (!Array.isArray(pt) || pt.length === 0) return "";
        if (pt.includes("free") && pt.includes("private")) return "both";
        return pt[0];
      },
      setPlatformTooltipVisibility(state) {
        if (!this.platformTooltipText(this.roomsPlatformType)) return;
        this.showPlatformTooltip = state;
      },
      getLink(id) {
        const app = this.getAppByName("website");
        const response = `/nav?to=${app.link}/models/?filter=hired%26record=${id}%23app`;
        return response;
      },
      getUser(ind) {
        return { ...ind, role: "model" };
      },
      getAvatarProps(user) {
        const classes = ["roomCard__imgModel"];
        classes.push(`roomCard__imgModel-${this.getPlatformClass(user?.platformType)}`);

        return { class: classes.join(" ") };
      },
      getUserIdentifier(user, idx, shift) {
        return user?._id || user?.id || `${shift}-${idx}`;
      },
      handleAvatarHover(identifier, user, state) {
        if (!this.isFreeUser(user)) return;
        this.hoveredFreeUserId = state ? identifier : this.hoveredFreeUserId === identifier ? null : this.hoveredFreeUserId;
      },
      shouldShowFreeTooltip(identifier, user) {
        return this.isFreeUser(user) && this.hoveredFreeUserId === identifier;
      },
      isFreeUser(user) {
        const allowed = ["free", "group"];
        return Array.isArray(user?.platformType) && user.platformType.some((t) => allowed.includes(t));
      },
    },
    beforeMount: async function () {
      const shiftsMap = {
        morning: "morning",
        late: "late",
        night: "nigth",
      };
      this.room.users.forEach((user) => {
        const shiftKey = shiftsMap[user.workShift.name];
        if (shiftKey) this[shiftKey].push(user);
      });
    },
  };
</script>

<style lang="scss">
  .roomCard {
    &__container {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      justify-content: end;
      gap: 8px;
      padding-left: 100px;
      :nth-child(0) {
        position: absolute;
        left: 0;
      }
    }
    &__text {
      width: 59%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 13px;
      margin-top: 7px;
      margin-left: 3px;
      text-transform: capitalize;
    }
    &__roomName {
      margin: 10px 0;
      white-space: nowrap;
      text-align: center;
      box-shadow: $shadow-little;
      color: $primary-color;
      height: 38px;
      text-transform: uppercase;
      width: 80px;
      font-weight: bold;
      padding: 8px;
      position: relative;
      cursor: default;

      @include bordered-box();
    }
    &__turn {
      display: flex;
      padding: 2px 5px;
      height: 38px;
      width: 145px;
      margin: 10px 0;
      box-shadow: $shadow-little;
    }
    &__link {
      display: flex;
      width: 100%;
      color: black;

      .tooltipContainer {
        left: 44%;
        top: -35px;
        padding: 4px 7px;
      }
    }
    &__avatarWrapper {
      position: relative;
      display: flex;
      align-items: center;
    }
    .m {
      background-color: $blue-primary;
    }
    .l {
      background-color: $yellow-color;
    }
    .n {
      background-color: $gray-color;
    }
    .r {
      background-color: rgba(0, 0, 0, 0.043);
      & :hover {
        text-decoration: none;
      }
    }
    &__else {
      box-shadow: $shadow-little;
      text-align: center;
      padding: 10px;
      width: auto;
      height: 38px;
      margin: 10px 0;
      &--true {
        background-color: $green-color;
        color: $camouflage-green;
      }
      &--false {
        background-color: $ghost;
        color: $black;
      }
    }
    &__else,
    &__roomName,
    &__turn {
      border-radius: 5px;
    }
    &__imgModel {
      width: 35px;
      height: 35px;
      border-radius: 100%;
      border: solid white 2px;
      margin-right: 5px;

      &-free {
        border: solid 2px $free;
      }
    }
  }
  @media screen and (min-width: 655px) {
    .roomCard {
      &__turn {
        width: 100%;
      }
    }
  }
  @media screen and (min-width: 800px) {
    .roomCard {
      &__turn {
        width: 98%;
      }
    }
  }

  @media screen and (min-width: ($tablet_width + 150px)) {
    .roomCard {
      &__turn {
        width: 228px;
        gap: 15px;
      }
      &__else {
        width: 228px;
      }
    }
  }
</style>
